import { render } from "./RiskNavBtn.vue?vue&type=template&id=1c664023&scoped=true"
import script from "./RiskNavBtn.vue?vue&type=script&lang=js"
export * from "./RiskNavBtn.vue?vue&type=script&lang=js"

import "./RiskNavBtn.vue?vue&type=style&index=0&id=1c664023&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c664023"]])

export default __exports__